import { render } from "./Documents.vue?vue&type=template&id=37d3f348&ts=true"
import script from "./Documents.vue?vue&type=script&lang=ts"
export * from "./Documents.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/kemet/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__